// States a service worker installation can get into.
var ServiceWorkerInstallationState;
(function (ServiceWorkerInstallationState) {
    // The service worker installation state is loading.
    ServiceWorkerInstallationState["Loading"] = "Loading";
    // The browser does not support service workers.
    ServiceWorkerInstallationState["Unsupported"] = "Unsupported";
    // The service worker is installed.
    ServiceWorkerInstallationState["Installed"] = "Installed";
    // An unexpected error occurred checking the service worker installation.
    ServiceWorkerInstallationState["Error"] = "Error";
})(ServiceWorkerInstallationState || (ServiceWorkerInstallationState = {}));
export default ServiceWorkerInstallationState;
